import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { PageSeo } from '../components/PageSeo';
import { SubpageLayout } from '../components/SubpageLayout';
import { INTERACT_CLUBS_IMAGE_SRC } from '../data/interactClubsContent';

/**
 * İnteract kulüpleri — URL: /interact-clubs
 */
export function InteractClubsPage() {
    const { t } = useTranslation();

    const paragraphs = useMemo(() => {
        const raw = t('interactClubs.paragraphs', { returnObjects: true });
        return Array.isArray(raw) ? raw : [];
    }, [t]);

    return (
        <>
            <PageSeo
                title={`${t('interactClubs.title')} — ${t('header.rotaryAlt')}`}
                description={t('seo.interactClubs')}
            />
            <SubpageLayout
                title={t('interactClubs.title')}
                subtitle={t('interactClubs.subtitle')}
                contentClassName="interact-clubs-page"
            >
            <div className="row g-4 g-xl-5 align-items-start">
                <div className="col-lg-5 col-xl-5">
                    <figure className="interact-clubs-figure mb-0">
                        <img
                            src={INTERACT_CLUBS_IMAGE_SRC}
                            alt={t('interactClubs.imageAlt')}
                            className="interact-clubs-hero-img"
                            loading="lazy"
                            decoding="async"
                        />
                    </figure>
                </div>
                <div className="col-lg-7 col-xl-7">
                    <div className="interact-clubs-prose">
                        {paragraphs.map((text, i) => (
                            <p key={i} className="interact-clubs-prose-p mb-0">
                                {text}
                            </p>
                        ))}
                    </div>
                </div>
            </div>
        </SubpageLayout>
        </>
    );
}
